"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLabelCartButtonClickEnum = void 0;
var EventLabelCartButtonClickEnum;
(function (EventLabelCartButtonClickEnum) {
    EventLabelCartButtonClickEnum["ContinueShopping"] = "Continue shopping";
    EventLabelCartButtonClickEnum["PaypalExpress"] = "PaypalExpress";
    EventLabelCartButtonClickEnum["ProceedToOrderData"] = "Proceed to order data";
    EventLabelCartButtonClickEnum["AddPackagingVariant"] = "Add packaging variant";
    EventLabelCartButtonClickEnum["SelectPackagingVariant"] = "Select packaging variant";
    EventLabelCartButtonClickEnum["AmazonPayExpress"] = "AmazonPay";
    EventLabelCartButtonClickEnum["Payback"] = "Collect PAYBACK";
    EventLabelCartButtonClickEnum["BuyNow"] = "Buy now";
    EventLabelCartButtonClickEnum["BuyWithPaypalRegular"] = "Buy with paypal";
    EventLabelCartButtonClickEnum["BuyWithAmazonPayRegular"] = "Buy with amazonPay";
})(EventLabelCartButtonClickEnum || (exports.EventLabelCartButtonClickEnum = EventLabelCartButtonClickEnum = {}));
//# sourceMappingURL=EventLabelCartButtonClickEnum.js.map